import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  langSelect: {
    position: "relative",
    "&, & .MuiButton-label": {
      padding: "0 !important",
    },
    "& .MuiButton-startIcon": {
      position: "absolute",
      left: 15,
      top: "50%",
      transform: "translateY(-50%)",
    },
  },
  menuList: {
    padding: "0 10px 0 25px",

    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },

    "& .MuiSelect-outlined": {
      paddingRight: "18px !important",
    },

    "& .MuiSelect-select:focus": {
      background: "none",
    },
  },
  // langSelect: {
  //   position: "relative",
  //   width: "48px !important",
  //   overflow: "hidden",
  //   "& .MuiSelect-select": {
  //     position: "relative",
  //     width: "50px !important",
  //     padding: 0,
  //     overflow: "hidden",
  //     minHeight: "0 !important",
  //     height: "0 !important",
  //   },
  //   "& .MuiSelect-icon": {
  //     top: "-27px !important",
  //     transform: "scale(0.8)",
  //   },
  //   "& .MuiInput-underline:before": {
  //     display: "none",
  //   },
  //   "& .MuiInput-underline:after": {
  //     display: "none",
  //   },
  // },
  // langBtn: {
  //   position: "absolute",
  //   width: 48,
  //   "& .MuiIconButton-label": {
  //     marginLeft: -3,
  //   },
  // },
  langBtnText: {
    width: 25,
    position: "relative",
    left: -4,
    "& svg": {
      position: "absolute",
      top: 2,
    },
  },
}));

export default useStyles;
